(function () {
  'use strict';

  function diagramHtml(imgUrl) {
    if (!imgUrl) return '';
    return (
      '<img class="csg-diagram__img" src="' + imgUrl + '" alt="Labelled diagram of ear piercing placements: rook, vertical helix, flat, helix, industrial, forward helix, contra conch, daith, conch, auricle (Australianos), tragus, mid helix, antitragus, upper lobe and lobe" loading="lazy" width="894" height="900" onerror="this.parentElement.hidden=true">' +
      '<p class="csg-diagram__note">Nose and belly piercings aren\'t shown here — nose sits in the nostril, belly sits in the top skin of the navel.</p>'
    );
  }

  function nearestIndex(arr, value) {
    var bestI = 0;
    var bestD = Infinity;
    for (var i = 0; i < arr.length; i++) {
      var d = Math.abs(arr[i] - value);
      if (d < bestD) { bestD = d; bestI = i; }
    }
    return bestI;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function fmtMm(n) {
    return (Math.round(n * 10) / 10) + 'mm';
  }

  function init(root) {
    var dataUrl = root.getAttribute('data-catalog');
    if (!dataUrl) return;

    fetch(dataUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) { build(root, data); })
      .catch(function () {
        root.innerHTML = '<p class="csg-error">Sorry — the size guide couldn\'t load. Please refresh the page.</p>';
      });
  }

  function build(root, data) {
    var state = {
      placement: null,
      jewelleryType: null,
      age: null,
      position: null,
      variant: null,
      fit: 'true'
    };

    var diagramUrl = root.getAttribute('data-diagram');
    var diagramBlock = diagramUrl
      ? '<details class="csg-diagram" open>' +
          '<summary>Which piercing do I have? See a diagram</summary>' +
          diagramHtml(diagramUrl) +
        '</details>'
      : '';

    root.innerHTML =
      '<div class="csg-app">' +
        diagramBlock +

        '<p class="csg-intro">Answer the 3 questions below to get your size recommendation.</p>' +

        '<div class="csg-step" data-step="placement">' +
          '<h3 class="csg-step__title"><span class="csg-step__num">Step 1</span> Which piercing is this for?</h3>' +
          '<div class="csg-pills" data-role="placement-pills"></div>' +
        '</div>' +

        '<div class="csg-step" data-step="type">' +
          '<h3 class="csg-step__title"><span class="csg-step__num">Step 2</span> Which style?</h3>' +
          '<div class="csg-pills" data-role="type-pills"></div>' +
          '<div class="csg-variant" data-role="variant" hidden></div>' +
        '</div>' +

        '<div class="csg-step" data-step="age">' +
          '<h3 class="csg-step__title"><span class="csg-step__num">Step 3</span> How old is the piercing?</h3>' +
          '<div class="csg-pills" data-role="age-pills"></div>' +
        '</div>' +

        '<div class="csg-result" data-role="result" hidden></div>' +

        '<div class="csg-measure" data-role="measure"></div>' +

        '<div class="csg-disclaimer">' +
          '<strong>A note on sizing:</strong> this guide gives a starting recommendation based on ' +
          'typical anatomy — everybody\'s is a little different. Cartilage or tissue thickness, ' +
          'swelling, and exactly where a piercing sits all shift the right size, sometimes by a full ' +
          'millimetre either way. If you\'re not sure, ask your piercer to measure you, or message us ' +
          'before you order. Please measure carefully before ordering — we don\'t offer refunds or ' +
          'exchanges on jewellery that doesn\'t fit, due to safety and hygiene reasons.' +
        '</div>' +
      '</div>';

    var els = {
      placementPills: root.querySelector('[data-role="placement-pills"]'),
      typePills: root.querySelector('[data-role="type-pills"]'),
      variant: root.querySelector('[data-role="variant"]'),
      agePills: root.querySelector('[data-role="age-pills"]'),
      result: root.querySelector('[data-role="result"]'),
      measure: root.querySelector('[data-role="measure"]')
    };

    if (data.howToMeasure) {
      var m = data.howToMeasure;
      var mHtml = '<button type="button" class="csg-measure__btn" aria-expanded="false"><span>' + m.heading + '</span><span class="csg-measure__chev" aria-hidden="true"></span></button>' + '<div class="csg-measure__body" hidden>';
      if (m.doubleCheck) mHtml += checkHtml(m.doubleCheck, true);
      if (m.intro) mHtml += '<p>' + m.intro + '</p>';
      (m.steps || []).forEach(function (s) {
        mHtml += '<h4>' + s.title + '</h4><p>' + s.body + '</p>';
      });
      if (m.notes && m.notes.length) {
        mHtml += '<ul>' + m.notes.map(function (n) { return '<li>' + n + '</li>'; }).join('') + '</ul>';
      }
      mHtml += '</div>';
      els.measure.innerHTML = mHtml;
      var mBtn = els.measure.querySelector('.csg-measure__btn');
      var mBody = els.measure.querySelector('.csg-measure__body');
      mBtn.addEventListener('click', function () {
        var open = mBtn.getAttribute('aria-expanded') === 'true';
        mBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        mBody.hidden = open;
      });
    } else {
      els.measure.hidden = true;
    }

    function checkHtml(c, withRefund) {
      return '<div class="csg-check" role="note"><span class="csg-check__icon" aria-hidden="true">!</span><div><strong class="csg-check__title">' + c.heading + '</strong><p>' + c.body + (withRefund && c.refund ? ' <strong>' + c.refund + '</strong>' : '') + '</p></div></div>';
    }

    function makePill(container, key, label, onClick) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'csg-pill';
      btn.textContent = label;
      btn.setAttribute('data-key', key);
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(container.children, function (c) {
          c.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        onClick(key);
      });
      container.appendChild(btn);
      return btn;
    }

    var typeLabels = { stud: 'Stud / flat-back', ring: 'Ring / hoop', barbell: 'Barbell / bar' };

    // Some placements (lobe rings) are sized by which piercing it is: main, 2nd, 3rd, stacked.
    function needsVariant() {
      return !!(state.placement && state.placement.ringVariants && state.jewelleryType === 'ring');
    }

    function renderVariant() {
      els.variant.innerHTML = '';
      if (!needsVariant()) { els.variant.hidden = true; state.variant = null; return; }
      var cfg = state.placement.ringVariants;
      els.variant.hidden = false;
      var t = document.createElement('p');
      t.className = 'csg-variant__label';
      t.textContent = cfg.heading;
      var pills = document.createElement('div');
      pills.className = 'csg-pills';
      els.variant.appendChild(t);
      els.variant.appendChild(pills);
      cfg.options.forEach(function (o) {
        var btn = makePill(pills, o.key, o.label, function (key) {
          state.variant = cfg.options.filter(function (x) { return x.key === key; })[0];
          maybeShowResult();
        });
        if (state.variant && state.variant.key === o.key) btn.classList.add('is-selected');
      });
    }

    function maybeShowResult() {
      if (state.placement && state.jewelleryType && state.age && (!needsVariant() || state.variant)) {
        renderResult();
      } else {
        els.result.hidden = true;
      }
    }

    function renderTypePills() {
      els.typePills.innerHTML = '';
      if (!state.placement) {
        els.typePills.innerHTML = '<p class="csg-hint">Choose your piercing in step 1 first.</p>';
        renderVariant();
        return;
      }
      var types = state.placement.types;
      if (types.indexOf(state.jewelleryType) === -1) state.jewelleryType = null;
      if (types.length === 1) state.jewelleryType = types[0];
      types.forEach(function (t) {
        var btn = makePill(els.typePills, t, ((state.placement[t] && state.placement[t].typeLabel) || typeLabels[t]), function (key) {
          state.jewelleryType = key;
          renderVariant();
          maybeShowResult();
        });
        if (state.jewelleryType === t) btn.classList.add('is-selected');
      });
      if (types.length === 1) {
        var hint = document.createElement('p');
        hint.className = 'csg-hint';
        hint.textContent = 'This is the only style that works for this piercing.';
        els.typePills.appendChild(hint);
      }
      renderVariant();
    }

    data.placements.forEach(function (p) {
      makePill(els.placementPills, p.key, p.label, function (key) {
        state.placement = data.placements.filter(function (x) { return x.key === key; })[0];
        state.position = null;
        state.variant = null;
        state.fit = 'true';
        renderTypePills();
        maybeShowResult();
      });
    });

    data.ages.forEach(function (a) {
      makePill(els.agePills, a.key, a.label, function (key) {
        state.age = data.ages.filter(function (x) { return x.key === key; })[0];
        maybeShowResult();
      });
    });

    renderTypePills();

    function renderResult() {
      var p = state.placement;
      var html = '';
      var gaugeInfo = data.gaugeByCategory[p.gaugeCategory] || data.gaugeByCategory.cartilage;

      var figureLabels = { stud: 'Post length', ring: 'Inner diameter', barbell: 'Bar length' };
      // While a piercing is still brand new or healing, we advise a flat-back
      // post rather than a ring, so show the post size where a stud exists.
      var effType = state.jewelleryType;
      // Where there's no stud (rook), the curved barbell is the healing-friendly alternative.
      var swapTo = p.stud ? 'stud' : (p.barbell ? 'barbell' : null);
      // A ring for a piercing that's sized by which one it is (lobe: main/2nd/3rd) uses that
      // variant's numbers; a stacked piercing can't take a ring at all, so it gets the post.
      var variant = (effType === 'ring' && p.ringVariants) ? state.variant : null;
      var noRing = !!(variant && variant.noRing && p.stud);
      var ringBlock = p.ring ? (variant && !variant.noRing ? Object.assign({}, p.ring, variant) : p.ring) : null;
      var swapToStud = !noRing && !!(state.age && (state.age.key === 'fresh' || state.age.key === 'healing') && effType === 'ring' && swapTo);
      if (swapToStud || noRing) effType = noRing ? 'stud' : swapTo;
      var swapName = swapTo === 'barbell' ? 'curved barbell' : 'flat-back post';
      var block = effType === 'ring' ? ringBlock : p[effType];
      var figureLabel = block.figureLabel || figureLabels[effType];

      var fitObj = data.fits.filter(function (f) { return f.key === state.fit; })[0];
      var lean = 0;
      // Fine-tuning only applies once fully healed. A must-measure placement
      // (e.g. industrial) is sized by anatomy a piercer confirms in person.
      var tuneActive = !!(state.age && state.age.key === 'healed' && !block.mustMeasureInPerson && !block.fixedStandard);
      if (tuneActive) {
        if (state.position) lean += state.position.delta;
        if (fitObj) lean += fitObj.delta;
        lean = clamp(lean, -1, 1);
      }
      var tunedMm = null;

      var baselineIdx = nearestIndex(block.availableMm, block.baselineMm);
      var typicalMm = block.availableMm[baselineIdx];
      var figureValue, subLine = '', leanLine = '';

      var showAsSingle = block.limitedSizes || block.fixedStandard || block.mustMeasureInPerson || (state.age && state.age.key === 'fresh' && block.freshMm);

      var ageCfg = block.byAge && state.age ? block.byAge[state.age.key] : null;

      if (ageCfg) {
        // Placements sized differently at each stage (e.g. lobe studs: longer while healing, shorter once healed).
        figureValue = fmtMm(ageCfg.range[0]) + '–' + fmtMm(ageCfg.range[1]);
        subLine = '<p class="csg-result__note csg-result__note--tip">' + ageCfg.note + '</p>';
        tunedMm = block.availableMm[clamp(baselineIdx + lean, 0, block.availableMm.length - 1)];
      } else if (showAsSingle) {
        var singleBaseline = (state.age && state.age.key === 'fresh' && block.freshMm) ? block.freshMm : block.baselineMm;
        var singleIdx = clamp(nearestIndex(block.availableMm, singleBaseline) + lean, 0, block.availableMm.length - 1);
        figureValue = fmtMm(block.availableMm[singleIdx]);
        tunedMm = block.availableMm[singleIdx];

        if (state.age && state.age.key === 'fresh' && block.freshMm && block.baselineMm !== block.freshMm) {
          leanLine = '<p class="csg-result__note csg-result__note--tip">Once the swelling settles (usually 8-12 weeks), you can size down toward ' + fmtMm(block.baselineMm) + ' for a closer fit.</p>';
        }
      } else if (block.rangeMm) {
        // Placements with a fixed recommended range (e.g. conch rings 10-12mm,
        // daith 8-10mm, with the baseline as the standard) show that range at every age.
        var rMin = block.rangeMm[0], rMax = block.rangeMm[1];
        figureValue = fmtMm(rMin) + '–' + fmtMm(rMax);
        subLine = '<p class="csg-result__note csg-result__note--tip">' + fmtMm(block.baselineMm) + ' is the standard recommendation most people are comfortable with. ' + fmtMm(rMax) + ' is for a thicker or deeper piercing, or a roomier fit.</p>';
        tunedMm = block.availableMm[clamp(baselineIdx + lean, 0, block.availableMm.length - 1)];
      } else {
        // Healing (2-6 months, the downsize window) allows one size below typical;
        // fully healed allows two. A piece that's still brand new hasn't reached
        // the downsize window yet, so it stays at the typical size, not a range —
        // and we never show a single small number in isolation once downsizing
        // does apply; the "most people" size is always called out too.
        var stepsDown = state.age && state.age.key === 'fresh' ? 0 : (state.age && state.age.key === 'healing' ? 1 : 2);
        var floorIdx = clamp(baselineIdx - stepsDown, 0, block.availableMm.length - 1);
        var floorMm = block.availableMm[floorIdx];

        if (floorMm === typicalMm) {
          figureValue = fmtMm(typicalMm);
        } else {
          figureValue = fmtMm(floorMm) + '–' + fmtMm(typicalMm);
          subLine = '<p class="csg-result__note csg-result__note--tip">' + fmtMm(typicalMm) + ' is the standard recommendation most people are comfortable with. ' + fmtMm(floorMm) + ' is only for those who already know they have less room here — it\'s not the default, so when in doubt, start at ' + fmtMm(typicalMm) + '.</p>';
        }

        var leanIdx = clamp(baselineIdx + lean, floorIdx, block.availableMm.length - 1);
        tunedMm = block.availableMm[leanIdx];
      }

      var freshNotice = '';
      var laterLine = '';
      var isConch = p.key === 'conch';
      var switchText = isConch
        ? 'switch to a ring once your piercer agrees it\'s ready or at 12 months.'
        : 'switch to a ring once your piercer agrees it\'s ready.';
      if (swapToStud) {
        var rb = ringBlock;
        var rbIdx = nearestIndex(rb.availableMm, rb.baselineMm);
        var rbTypical = rb.availableMm[rbIdx];
        var rbFloor = rb.availableMm[clamp(rbIdx - 2, 0, rb.availableMm.length - 1)];
        var ringLater = rb.rangeMm ? fmtMm(rb.rangeMm[0]) + '–' + fmtMm(rb.rangeMm[1]) : (rbFloor === rbTypical ? fmtMm(rbTypical) : fmtMm(rbFloor) + '–' + fmtMm(rbTypical));
        laterLine = '<p class="csg-result__note csg-result__note--tip">' + (isConch ? 'Once your piercer agrees it\'s ready, or at 12 months, ' : 'Once your piercing is fully healed (around 9 months) and your piercer agrees, ') + 'a ring for this placement would be ' + ringLater + ' inner diameter.</p>';
      }
      if (noRing) {
        freshNotice = '<div class="csg-callout"><strong>A stacked lobe can\'t take a ring.</strong> ' + variant.note + ' The flat-back post size below is what we advise for it.</div>';
      }
      if (state.age && state.age.key === 'fresh') {
        freshNotice += '<div class="csg-callout"><strong>Brand new piercing — please don\'t change your jewellery yourself yet.</strong> ' +
          'There is still a long way to go with healing. Leave your jewellery in until your piercer confirms the swelling has settled, and let them do the downsize. ' +
          'A downsize is about getting the right fit, not a new look, so don\'t swap to something decorative yet.' +
          (swapTo ? ' And please don\'t change to a ring while the piercing is still healing.' : '') +
          (swapToStud ? ' The size below is the ' + swapName + ' we advise instead of a ring; ' + switchText : '') + '</div>';
      } else if (swapToStud) {
        freshNotice = '<div class="csg-callout"><strong>Still healing — hold off on rings.</strong> ' +
          'Please don\'t change to a ring until the piercing is fully healed' + (isConch ? '' : ' (around 9 months)') + '. The ' + swapName + ' size below is what we advise wearing until then; ' + switchText + '</div>';
      }

      html +=
        '<h3 class="csg-result__title">Your recommendation</h3>' +
        freshNotice +
        '<div class="csg-result__figures">' +
          '<div class="csg-figure"><span class="csg-figure__value">' + gaugeInfo.label + '</span><span class="csg-figure__label">Gauge</span></div>' +
          '<div class="csg-figure"><span class="csg-figure__value">' + figureValue + '</span><span class="csg-figure__label">' + figureLabel + '</span></div>' +
        '</div>' +
        '<p class="csg-result__note">' + block.note + '</p>' +
        subLine + leanLine + laterLine;

      if (block.limitedSizes) {
        html += '<p class="csg-result__note csg-result__note--tip">This placement only comes in a couple of fixed sizes, so treat the number above as "closest available" rather than exact.</p>';
      }
      if (block.mustMeasureInPerson) {
        html += '<p class="csg-result__note csg-result__note--tip">This is not something to self-measure or order sight-unseen — have your piercer confirm the exact length before you buy.</p>';
      }

      html += '<div class="csg-tune" data-role="tune"></div>';

      html += '<p class="csg-result__gauge-note">Every Cura piece for this placement is implant-grade titanium at ' + gaugeInfo.label + ' thickness — that part never changes. This guide only helps you pick the length or diameter that will sit comfortably in your piercing. Between two sizes, or want to check against a piece you already own? See "How to measure yourself" below.</p>';

      if (data.howToMeasure && data.howToMeasure.doubleCheck) html += checkHtml(data.howToMeasure.doubleCheck);

      // Flat-back (stud) results only: every Cura piece ships with a 6mm post, so
      // point people at the 4-12mm post-only product for a shorter/longer one.
      // Cartilage (16G) only: that product is 16G, so nose (18G) must not link to it.
      var postsCfg = data.shorterLongerPosts;
      var showPosts = !!(postsCfg && effType === 'stud' && (postsCfg.gaugeCategories || []).indexOf(p.gaugeCategory) !== -1);
      if (showPosts) html += '<p class="csg-post-note">' + postsCfg.text + '</p>';

      var shopUrl = block.shopUrl || shopLinkFor(p.key, p.label);
      var shopText = block.shopLabel || ('Shop ' + p.label + ' jewellery');
      html += '<div class="csg-result__ctas">' +
        '<a class="csg-result__cta button" href="' + shopUrl + '">' + shopText + '</a>' +
        (showPosts ? '<a class="csg-result__cta csg-result__cta--alt" href="' + postsCfg.url + '">' + postsCfg.button + '</a>' : '') +
      '</div>';

      var refBase = (block.limitedSizes || block.fixedStandard || block.mustMeasureInPerson) ? block.baselineMm : typicalMm;
      var wasHidden = els.result.hidden;
      els.result.innerHTML = html;
      els.result.hidden = false;
      buildTune(els.result.querySelector('[data-role="tune"]'), tuneActive, tunedMm, refBase);
      if (wasHidden) els.result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    var POSITION_TEXT = {
      close: 'your piercing sits close to the edge',
      middle: 'your piercing sits in the middle of the fold',
      deep: 'your piercing is set further in'
    };
    var FIT_TEXT = {
      snug: 'you like a snug fit',
      loose: 'you like a looser fit'
    };

    function tunedHtml(tunedMm, refBase) {
      var reasons = [];
      if (state.position && POSITION_TEXT[state.position.key]) reasons.push(POSITION_TEXT[state.position.key]);
      if (FIT_TEXT[state.fit]) reasons.push(FIT_TEXT[state.fit]);
      if (!state.position && !FIT_TEXT[state.fit]) return '';
      var because = reasons.length ? 'Because ' + reasons.join(' and ') + ', ' : '';
      var msg;
      if (tunedMm === refBase) {
        msg = because + fmtMm(tunedMm) + ' is the right size for you — the same as the standard recommendation.';
      } else if (tunedMm < refBase) {
        msg = because + 'we\'d suggest ' + fmtMm(tunedMm) + ' — a little smaller than the standard ' + fmtMm(refBase) + '.';
      } else {
        msg = because + 'we\'d suggest ' + fmtMm(tunedMm) + ' — a little larger than the standard ' + fmtMm(refBase) + '.';
      }
      return '<div class="csg-tuned"><span class="csg-tuned__label">Fine-tuned for you</span><span class="csg-tuned__value">' + fmtMm(tunedMm) + '</span><p>' + msg + '</p></div>';
    }

    function buildTune(box, tuneActive, tunedMm, refBase) {
      var block = state.placement[state.jewelleryType];
      if (!tuneActive || block.mustMeasureInPerson) { box.hidden = true; return; }
      box.innerHTML = '<h4 class="csg-tune__title">Fine-tune your result (optional)</h4>';

      function group(title, items, current, onPick) {
        var wrap = document.createElement('div');
        wrap.className = 'csg-tune__group';
        var t = document.createElement('p');
        t.className = 'csg-tune__label';
        t.textContent = title;
        var pills = document.createElement('div');
        pills.className = 'csg-pills';
        wrap.appendChild(t);
        wrap.appendChild(pills);
        items.forEach(function (it) {
          var btn = makePill(pills, it.key, it.label, function (key) {
            onPick(items.filter(function (x) { return x.key === key; })[0]);
          });
          if (current === it.key) btn.classList.add('is-selected');
        });
        box.appendChild(wrap);
      }

      if (state.placement.positionMatters) {
        group('Where does it sit on the fold?', data.positions, state.position && state.position.key, function (pos) {
          state.position = pos;
          renderResult();
        });
      }
      group('How do you want it to fit?', data.fits, state.fit, function (f) {
        state.fit = f.key;
        renderResult();
      });
      var th = tunedHtml(tunedMm, refBase);
      if (th) box.insertAdjacentHTML('beforeend', th);
    }

    function shopLinkFor(key, label) {
      if (window.Shopify && root.getAttribute('data-collections-base')) {
        return root.getAttribute('data-collections-base') + key;
      }
      return '/search?type=product&q=' + encodeURIComponent(label);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-cura-sizeguide]');
    roots.forEach ? roots.forEach(init) : Array.prototype.forEach.call(roots, init);
  });
})();
